import styled from "@emotion/styled";
import { padding } from "polished";
import React, { PropsWithChildren } from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { getModuleThemeColors } from "@brexhq/next/src/components/pageBuilder/ModuleLayout";
import {} from "@brexhq/shared/styles/theming";

export const Row = styled.tr<{ rowCount: number; rowIndex: number }>(
  ({ rowIndex, rowCount }) => {
    const borderColor = `1px solid ${
      getModuleThemeColors("PrimaryGray").standard.borders
    }`;

    return {
      borderTop: rowIndex === 0 ? undefined : borderColor,
      borderBottom: rowIndex === rowCount - 1 ? borderColor : undefined,
    };
  },
);

const Table = styled.table({ borderCollapse: "collapse", margin: 0 });

interface BaseProps {
  verticalAlign?: React.CSSProperties["verticalAlign"];
}

type CellProps =
  | ({
      readonly as: "td";
    } & BaseProps)
  | ({
      readonly as: "th";
      scope: "col" | "row";
    } & BaseProps);

export const Cell = styled.td<CellProps>(({ theme, verticalAlign }) => {
  return {
    ...padding(theme.spacing.p16, theme.spacing.p24),
    margin: 0,
    verticalAlign,
    background: "none",
  };
});

export const ArticleTable: React.FC<PropsWithChildren> = ({ children }) => (
  <Container
    overflowX={{
      LRG: "auto",
      MED: "auto",
      SML: "auto",
    }}
  >
    <Table>
      <tbody>{children}</tbody>
    </Table>
  </Container>
);
